import { useTranslation } from 'react-i18next';
import { formatDate, formatDayname } from '@steelbuy/ts-shared';
import { CardContentLabelValues } from '@steelbuy/ui-primitive';

export const CardContentQuoteDeadline = ({ deadline }: { deadline: string }) => {
    const { t } = useTranslation('translation');
    const date = new Date(Number(deadline));
    const labelValues = [
        {
            label: t('application.createRFQ.quoteDeadline.subHeader'),
            value: `${formatDayname(date)}, ${formatDate(date)}`,
        },
    ];

    return <CardContentLabelValues title={t('application.createRFQ.quoteDeadline.header')} labelValues={labelValues} />;
};
